import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { OwnershipModel } from "../new-dwellings-filter.model";

@Component({
    selector: "new-dwellings-filter-ownership",
    imports: [],
    templateUrl: "./new-dwellings-filter-ownership.component.html",
    styleUrl: "./new-dwellings-filter-ownership.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingsFilterOwnershipComponent {
    filterForm = input.required<FieldTree<OwnershipModel[]>>();
    expanded = signal(true);

    toggleExpanded(): void {
        this.expanded.update((v) => !v);
    }

    toggleSelected(option: OwnershipModel): void {
        const field = this.filterForm();
        field().value.set(field().value().map((o) => (o.value === option.value ? { ...o, selected: !o.selected } : o)));
    }
}
